import { render, staticRenderFns } from "./PosFooterDefault.vue?vue&type=template&id=7ef4674a&scoped=true"
import script from "./PosFooterDefault.vue?vue&type=script&lang=js"
export * from "./PosFooterDefault.vue?vue&type=script&lang=js"
import style0 from "./PosFooterDefault.vue?vue&type=style&index=0&id=7ef4674a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef4674a",
  null
  
)

export default component.exports